
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CorpEventsLog from "@/modules/Corps/components/corpPopup/CorpEventsLog.vue";

  interface IPayload {
    corpId: number;
    closeAction?: Function;
  }

  @Component({
    components: {
      CorpEventsLog,
      AppDialog,
    },
  })
  export default class AccountLogPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'profile', dialogName: 'accountLogPopup' };

    get payloadPopup(): IPayload { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
